function PlynarenskeTechnologie(){
    return (
        <div>
            PlynarenskeTechnologie
        </div>
    );
};

export default PlynarenskeTechnologie;